import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BadgeFlag from 'components/shared/BadgeFlag';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  StyledAds,
  StyledContainer,
  StyledFeatureItem,
  StyledFeatures,
  StyledItem,
  StyledList,
  StyledPrice,
  StyledTitle,
  StyledValue,
  StyledWrapper
} from './DailyPricing.styled';

const DailyPricing: React.FC = () => {
  const { t } = useI18n('manfred-daily');

  const pricing = [
    {
      title: t('manfred-daily.pricing.tier1.title'),
      ads: t('manfred-daily.pricing.tier1.ads'),
      features: [
        t('manfred-daily.pricing.tier1.feature1'),
        t('manfred-daily.pricing.tier1.feature2')
      ],
      price: t('manfred-daily.pricing.tier1.price')
    },
    {
      title: t('manfred-daily.pricing.tier2.title'),
      ads: t('manfred-daily.pricing.tier2.ads'),
      features: [
        t('manfred-daily.pricing.tier2.feature1'),
        t('manfred-daily.pricing.tier2.feature2'),
        t('manfred-daily.pricing.tier2.feature3')
      ],
      price: t('manfred-daily.pricing.tier2.price'),
      discount: t('manfred-daily.pricing.tier2.discount')
    },
    {
      title: t('manfred-daily.pricing.tier3.title'),
      ads: t('manfred-daily.pricing.tier3.ads'),
      features: [
        t('manfred-daily.pricing.tier3.feature1'),
        t('manfred-daily.pricing.tier3.feature2'),
        t('manfred-daily.pricing.tier3.feature3'),
        t('manfred-daily.pricing.tier3.feature4')
      ],
      price: t('manfred-daily.pricing.tier3.price'),
      discount: t('manfred-daily.pricing.tier3.discount')
    }
  ];

  return (
    <StyledWrapper>
      <StyledContainer>
        <Heading2 editorial>{t('manfred-daily.pricing.title')}</Heading2>
        <StyledList>
          {pricing.map((item, index) => (
            <StyledItem key={index}>
              <StyledTitle>{item.title}</StyledTitle>
              <StyledAds>{item.ads}</StyledAds>
              <StyledFeatures>
                {item.features.map((feature, index) => (
                  <StyledFeatureItem key={index}>
                    <FontAwesomeIcon icon={faCheckCircle} />
                    <span>{feature}</span>
                  </StyledFeatureItem>
                ))}
              </StyledFeatures>
              <StyledPrice>
                <StyledValue>{item.price}</StyledValue>
                {item.discount && (
                  <BadgeFlag color="positive" text={item.discount} />
                )}
              </StyledPrice>
            </StyledItem>
          ))}
        </StyledList>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default DailyPricing;
